import { isWeb3UserMigrationDoneAtom, sessionAtom } from '@capsicum/common';
import { useMe } from '@capsicum/socios-core';
import { useWeb3UserMigration } from '@socios-blk/core';
import { useAtom, useAtomValue } from 'jotai';
import { useEffect } from 'react';

export const useWeb3Migration = () => {
	const { me } = useMe();
	const isMigrationDoneOrNotNeeded =
		me.metadata?.web3MigrationDoneOrNotNeeded === undefined ? false : me.metadata?.web3MigrationDoneOrNotNeeded;
	const sessionTokens = useAtomValue(sessionAtom);
	const [isWeb3UserMigrationDone, setWeb3UserMigrationDone] = useAtom(isWeb3UserMigrationDoneAtom);
	const { isMigrationDataLoading, isMigrationDone, isMigrationError, isMigrationFailed, isMigrationOngoing } =
		useWeb3UserMigration({
			enabled: !isMigrationDoneOrNotNeeded && !isWeb3UserMigrationDone && !!sessionTokens?.authToken
		});

	useEffect(() => {
		if (isMigrationDoneOrNotNeeded || isMigrationDone) {
			setWeb3UserMigrationDone(true);
		}
	}, [isMigrationDone, isMigrationDoneOrNotNeeded]);

	return {
		isMigrationDataLoading,
		isMigrationDone: isMigrationDone || isMigrationDoneOrNotNeeded,
		isMigrationError,
		isMigrationFailed,
		isMigrationOngoing
	};
};
